var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq"},[_c('h3',{staticClass:"h3 faq-heading"},[_vm._v("\n    Frequently Asked Questions\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    This section answers some common questions about "+_vm._s(_vm.$store.state.calculators.calculatorName)+".\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }